import type { FC } from "react";
import { Icon } from "../../shared/components/Icon/Icon";
import classes from "./Download.module.scss";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

export const Download: FC = () => {
	const { t } = useTranslation();

	return (
		<div className={classes.wrapper}>
			<div className={classes.content}>
				<div className={classes.banner}>
					<h1 className={classes.title}>{t("translation.download")}</h1>
					<div className={classes.links}>
						<div className={classes.icons}>
							<Icon className={classes.icon} name="appstore" />
							<Icon className={classes.qr} name="appstore_qr" />
						</div>

						<div className={classes.icons}>
							<Icon className={classes.icon} name="google" />
							<Icon className={classes.qr} name="google_qr" />
						</div>
					</div>
				</div>
				<motion.img
					className={classes.image}
					src="images/phone-download.png"
					alt=""
					animate={{
						y: [-10, 10, -10],
					}}
					transition={{
						duration: 5,
						repeat: Infinity,
						repeatType: "reverse",
					}}
				/>
			</div>
		</div>
	);
};
